/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import "./styles.scss";

// Local Definitions

const baseClassName = styleNames.base;
const componentClassName = 'dot-info';

/**
 * This is the component description.
 */
const DotInfo = ({
  id,
  className: userClassName,
  style,
  booleanValue,
  height,
  colorTrue,
  colorFalse,
  colorEmpty
  // ...otherProps
}) => /*#__PURE__*/React.createElement("div", {
  id: id,
  className: [baseClassName, booleanValue === false && `x-${colorFalse}`, booleanValue === true && `x-${colorTrue}`, [null, undefined].includes(booleanValue) && `empty x-${colorEmpty}`, componentClassName, userClassName].filter(e => e).join(' '),
  style: {
    '--height': height,
    ...style
  }
});
DotInfo.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   *  Boolean value to be converted into string
   */
  booleanValue: PropTypes.bool,
  /**
   * Color for true case
   */
  colorTrue: PropTypes.string,
  /**
   * Color for false case
   */
  colorFalse: PropTypes.string,
  /**
   * Color for the border when empty value
   */
  colorEmpty: PropTypes.string,
  /**
   * The height of the dot
   */
  height: PropTypes.string
};
DotInfo.defaultProps = {
  colorTrue: 'success',
  colorFalse: 'error',
  colorEmpty: 'metadata',
  height: '2em'
  // someProp:false
};
export default DotInfo;